import dayjs from "dayjs"
import * as timeago from "timeago.js"
import _Vue from "vue"
import prettyMs from "pretty-ms"

declare interface Format {
    formatDuration(secs: number): string
    formatDate(date: Date | number, format?: string): string
    formatTime(date: Date | number, format?: string): string
    formatDateTime(date: Date | number, format?: string): string
    formatRelativeDateTime(timestamp: number): string
}

const formatter = {} as Format

formatter.formatDuration = (secs: number): string => {
    return prettyMs(secs * 1000)
}

formatter.formatDate = (date: Date | number, format?: string): string => {
    return dayjs(date).format(format || "MMM DD, YYYY")
}

formatter.formatTime = (date: Date | number, format?: string): string => {
    return dayjs(date).format(format || "HH:mm:ss")
}

formatter.formatDateTime = (date: Date | number, format?: string): string => {
    return dayjs(date).format(format || "YYYY-MM-DD HH:mm:ss")
}

formatter.formatRelativeDateTime = (timestamp: number): string => {
    return timeago.format(timestamp)
}

export default {
    install: (Vue: typeof _Vue): void => {
        Vue.prototype.$F = formatter
    },
}

declare module "vue/types/vue" {
    interface Vue {
        $F: Format
    }
}
